import { CategoryWithId } from "../interfaces/ICategories";
import { createContext, ReactNode, useContext } from "react";

interface ContestCategoriesContextType {
  categories: CategoryWithId[];
}

const ContestCategoriesContext = createContext<ContestCategoriesContextType | undefined>(undefined);

export default function ContestCategoriesProvider({
  categories,
  children,
}: {
  categories: CategoryWithId[];
  children: ReactNode;
}) {
  return (
    <ContestCategoriesContext.Provider value={{ categories }}>
      {children}
    </ContestCategoriesContext.Provider>
  );
}

export const useContestCategoriesContext = (): ContestCategoriesContextType => {
  const context = useContext(ContestCategoriesContext);
  if (context === undefined) {
    throw new Error(
      "Błąd w ContestCategoriesContext: useContestCategories must be used within an ContestCategoriesProvider"
    );
  }
  return context;
};
